import { currency } from "../../../../../../../services/utilities";

// "June 29, 2025" -> day 29 and Sunday, the month and year are on the hero
const toDay = (title = "") => {
  const date = new Date(title);
  if (isNaN(date)) return { day: title, weekday: "" };
  return {
    day: date.getDate(),
    weekday: date.toLocaleDateString("en-PH", { weekday: "long" }),
  };
};

const Header = ({ title, index, activeId, sum }) => {
  const { day, weekday } = toDay(title);
  return (
    <label className="d-flex justify-content-between">
      <span title={title}>
        <strong>{day}</strong>
        {weekday && <span className="ml-2">{weekday}</span>}
      </span>
      <small>
        {currency.format(sum)}
        <span
          style={{ rotate: `${activeId === index ? 0 : 90}deg` }}
          className="fa fa-angle-down transition-all ml-2"
        />
      </small>
    </label>
  );
};

export default Header;
